import React from 'react'

export default function Redeem() {
    return (
        <div id="redeem-container">
            <h1 style={{color:"#40a9ff"}}>Redeem Coins</h1>


            <p>Currently this service is not available!</p>
        </div>
    )
}
